// extracted by mini-css-extract-plugin
export default {"selectBox":"selector_selectBox__X9U2i","selectBox2":"selector_selectBox2__4GR1S"};